export default "__VITE_ASSET__304bdb62__"